import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Navigate } from 'react-router';

import { So5LeaderboardType } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsLoggedIn } from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import { WalletLanding } from '@sorare/gameplay/src/components/landing/WalletLanding/index.tsx';

import social from './assets/social.webp';

const messages = defineMessages({
  metadatasTitle: {
    defaultMessage: 'The Real Fantasy Ligue 1 Game – Sorare Football',
  },
  metadatasDescription: {
    defaultMessage:
      "Collect, play and win officially licensed digital cards featuring players from the Ligue 1, the world's best football league on Sorare",
  },
});

const FootballPage = () => {
  const { generateSportContextPath } = useSportContext();
  const isLoggedIn = useIsLoggedIn();
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();

  useEffect(
    () =>
      setPageMetadata(formatMessage(messages.metadatasTitle), {
        img: social,
        description: formatMessage(messages.metadatasDescription),
      }),
    [setPageMetadata, formatMessage]
  );

  if (isLoggedIn) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_PLAY)} replace />;
  }

  return (
    <WalletLanding
      variant="ligue1"
      leaderboards={[
        So5LeaderboardType.IN_SEASON_FRANCE_LIMITED,
        So5LeaderboardType.IN_SEASON_FRANCE_RARE,
        So5LeaderboardType.IN_SEASON_FRANCE_SUPER_RARE,
      ]}
    />
  );
};

export default FootballPage;
